export const ORDER_CONFIG = {
  ORDER_ITEM_OVERVIEW: {
    endPoint: 'order-item-overview',
  },
  ORDER_ITEM_OVERVIEW_SUBITEM_COL_CONFIG: {
    endPoint: 'order-item-overview-sub-item-column-config',
  },
  ORDER_ITEM_OVERVIEW_GENERAL_DETAILS: {
    mockPath: '/src/services/schema/OrderItemOverview/generalDetails.json',
  },
  ORDER_ITEM_OVERVIEW_DELIVERY_STATUS_INFO: {
    mockPath: '/src/services/schema/OrderItemOverview/deliveryAndStatusInfo.json',
  },
  ORDER_ITEM_OVERVIEW_FULFILLMENT: {
    mockPath: '/src/services/schema/OrderItemOverview/TransactionDetails/fulfillment.json',
  },
  ORDER_ITEM_OVERVIEW_ADJUSTMENT: {
    mockPath: '/src/services/schema/OrderItemOverview/TransactionDetails/adjustments.json',
  },
  ORDER_ITEM_OVERVIEW_TAXES_INFORMATION: {
    mockPath: '/src/services/schema/OrderItemOverview/TransactionDetails/taxesinformation.json',
  },
  ORDER_ITEM_OVERVIEW_ITEM_DISCOUNT: {
    mockPath: '/src/services/schema/OrderItemOverview/DiscountInformation/itemDiscount.json',
  },
}
